import { createContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import useLocalStorage from "../hooks/useLocalStorage";

export const CompanyContext = createContext({});

export const CompanyProvider = ({ children }: any) => {
  const [companyLoader, setCompanyLoader] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [company, setCompany] = useLocalStorage<any>("company");
  useEffect(() => {
    if (company) {
      setSelectedCompany(company);
      axiosInstance.defaults.headers.common["company"] = company.id;
    }
    setCompanyLoader(false);
  }, []);
  const handleChangeCompany = (value: any) => {
    setSelectedCompany(value);
    axiosInstance.defaults.headers.common["company"] = value.id;
    setCompany(value);
  };

  return (
    <CompanyContext.Provider value={{ selectedCompany, handleChangeCompany, companyLoader }}>
      {children}
    </CompanyContext.Provider>
  );
};
